var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighefficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39027_109343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16106 9.01652C3.37688 11.9205 4.19397 15.83 7.15704 17.5005C10.1209 19.1718 14.0503 18.6575 16.4344 16.3436C15.0166 17.8215 13.1487 18.8502 11.0879 18.9784C7.86633 19.1711 4.13065 17.9504 2.77688 14.8012C1.55352 11.844 2.90578 8.30945 5.73995 6.70188C8.25302 5.22402 11.2817 4.83787 13.9221 6.0593C15.9188 7.02279 17.7867 9.27295 16.9492 11.5224C15.9188 14.0934 12.5691 14.4796 10.056 14.2861C8.76784 14.1579 7.47965 13.7088 6.38518 12.9365C8.31709 14.2224 10.7653 14.0934 12.891 13.3864C14.1791 12.9365 15.5962 12.1005 15.7259 10.6218C16.0477 7.92255 13.2136 6.12303 10.7661 6.05855C8.57487 6.05855 6.38593 7.02204 5.16181 9.01502",
    fill: "#FF8400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5357 10.1762C13.7023 10.4259 13.5078 10.8368 13.1732 10.7761C13.0337 10.7506 12.9568 10.6029 12.9146 10.4694C12.7835 10.0563 12.7804 9.60115 12.5762 9.21875C13.0111 9.39345 13.2862 9.8036 13.5357 10.177",
    fill: "#FF1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9896 11.3321C11.9218 11.5593 11.6549 11.7017 11.4281 11.5915C11.168 11.4648 11.1439 11.1251 11.0836 10.8777C11.012 10.5838 10.96 10.2861 10.96 9.98242C11.41 10.3041 12.1833 10.6895 11.9904 11.3321",
    fill: "#FF1800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19449 4.70257C2.72439 5.23043 3.48042 5.5356 3.55956 6.37163C3.16609 6.25616 2.78318 6.10545 2.40479 5.94724C1.86509 5.7208 1.33067 5.47786 0.824888 5.18319C0.56333 5.03098 0.30328 4.85927 0.129913 4.61259C0.0402147 4.48512 -0.026117 4.32691 0.0100639 4.17545C0.065089 3.94301 0.333431 3.82605 0.573129 3.81555C0.890466 3.80205 1.20403 3.91452 1.47238 4.08398C1.74298 4.25418 1.96911 4.47912 2.19449 4.70331",
    fill: "#10319C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38259 1.61826C6.7052 2.26084 6.96223 2.83969 6.96223 3.54675C6.96223 3.61199 6.83334 3.73945 6.70445 3.67572C6.27781 3.46353 5.89565 2.85469 5.62505 2.47979C5.46299 2.25559 5.30847 2.02541 5.15394 1.79597C4.98585 1.54703 4.80193 1.26586 4.91048 0.952437C5.01223 0.659265 5.36123 0.401333 5.67404 0.52655C6.1248 0.719249 6.18887 1.23361 6.38259 1.61901",
    fill: "#10319C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 1.61812C12.0561 2.12274 11.8744 2.58836 11.3754 2.89428C11.3317 2.87404 11.3181 2.8208 11.3106 2.77356C11.196 2.06575 11.3129 1.34294 11.4297 0.635127C11.4486 0.523406 11.4674 0.408686 11.5194 0.307463C11.6279 0.0960187 11.8805 -0.0276988 12.1164 0.00529255C12.3523 0.0382839 12.5581 0.218986 12.6297 0.445427C12.7609 0.859318 12.4865 1.26346 12.3086 1.61812Z",
    fill: "#10319C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3343 3.546C16.7313 3.99663 16.1185 4.43226 15.4092 4.70294C15.514 4.23357 15.774 3.81518 16.0401 3.41403C16.2308 3.12686 16.426 2.84268 16.6273 2.56301C16.7923 2.33282 16.9921 2.08613 17.274 2.05089C17.565 2.01415 17.8431 2.23459 17.9494 2.50602C18.1567 3.03313 17.6931 3.27757 17.3351 3.54525",
    fill: "#10319C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39027_109343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighefficiency);
export default __webpack_public_path__ + "static/media/highefficiency.a97c0de2529d6411e4a47ea46211d9dc.svg";
export { ForwardRef as ReactComponent };